import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import conf from "./../../../config.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { Modal } from "react-bootstrap";
import SweetAlert from "sweetalert2-react";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import { UserButtonLoading } from "../../partials/loadings/ComponentLoading.js";
import KenaikanSiswa from "./KenaikanSiswa";

// Custom select styles with modern look
const selectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    borderRadius: "12px",
    minWidth: "12rem",
    border: isFocused ? "2px solid #6366f1" : "1px solid #e5e7eb",
    boxShadow: isFocused ? "0 0 0 3px rgba(99, 102, 241, 0.1)" : "none",
    "&:hover": {
      borderColor: "#6366f1",
    },
  }),
  option: (styles, { isSelected, isFocused }) => ({
    ...styles,
    backgroundColor: isSelected ? "#6366f1" : isFocused ? "#eef2ff" : "white",
    color: isSelected ? "white" : "#1f2937",
  }),
};

const dataKurikulum = [
  { value: "k13", label: "K13" },
  { value: "merdeka", label: "Merdeka" },
];

export default class TambahSiswaKeRombel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // URLs
      activeTab: "tambah",
      url: `${conf.uri_backend}api/v1/rombel/table-tambah`,
      url_naik_kelas: `${conf.uri_backend}api/v1/rombel/kenaikan`,
      url_get_rombel: `${conf.uri_backend}api/v1/rombel/get_rombel`,
      url_get_spektrum: `${conf.uri_backend}api/v1/rombel/get_spektrum`,
      url_get_smk: `${conf.uri_backend}api/v1/referensi/struktur-kurikulum`,

      // Session & Institution
      data_session: null,
      institusi_id_select: null,
      jenjang_id_select: null,
      tahunSekarang: new Date().getFullYear(),

      // Alert states
      show_alert: false,
      title_alert: "",
      message_alert: "",
      icon_alert: "",

      // Filter values
      tahun_ajaran_search: "",
      filterKurikulumSearch: "",
      kelas_search: "",
      peminatan_search: "",
      bidang_search: "",
      program_search: "",
      kompetensi_search: "",
      rombel_search: "",
      rombel_search_label: "",
      searchText: "",

      // Filter data options
      data_tahun_ajaran: [],
      data_kelas: [],
      data_peminatan: [],
      data_bidang: [],
      data_program: [],
      data_kompetensi: [],
      data_rombel: [],

      // Loading states
      loadingFilter: true,
      loading_peminatan: false,
      loading_bidang: false,
      loading_program: false,
      loading_kompetensi: false,
      loading_rombel: false,
      loading_submit: false,
      loadingSearch: false,

      // Display states
      showFilter: true,
      showDataTable: false,
      showSidebar: false,
      mode_show: 10,
      query: "",

      // FIXED: Persistent selection across pagination using Map
      selectedStudents: new Map(), // Map<id, studentData>

      // Modals
      showConfirmModal: false,
      showResultModal: false,
      resultData: null,
    };

    // Bind methods
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);
    this.getKelas = this.getKelas.bind(this);
    this.getPeminatanSMA = this.getPeminatanSMA.bind(this);
    this.getBidang = this.getBidang.bind(this);
    this.getProgram = this.getProgram.bind(this);
    this.getKompetensi = this.getKompetensi.bind(this);
    this.getRombel = this.getRombel.bind(this);

    this.filterTahunAjaran = this.filterTahunAjaran.bind(this);
    this.filterKurikulum = this.filterKurikulum.bind(this);
    this.filterKelas = this.filterKelas.bind(this);
    this.filterPeminatan = this.filterPeminatan.bind(this);
    this.filterBidang = this.filterBidang.bind(this);
    this.filterProgram = this.filterProgram.bind(this);
    this.filterKompetensi = this.filterKompetensi.bind(this);
    this.filterRombel = this.filterRombel.bind(this);

    this.setFilter = this.setFilter.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.toggleStudentSelection = this.toggleStudentSelection.bind(this);
    this.selectAllOnPage = this.selectAllOnPage.bind(this);
    this.clearAllSelections = this.clearAllSelections.bind(this);
    this.removeFromSelection = this.removeFromSelection.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.confirmSubmit = this.confirmSubmit.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, () => {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/${this.state.data_session.access_to}`,
                { headers: { Authorization: tokenApi } },
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                  },
                  () => {
                    this.loadInitialData();
                  },
                );
              });
          });
        });
    }
  }

  loadInitialData() {
    this.getTahunAjaranNow();
    this.getKelas();
    this.loadSavedFilter();
  }

  // Get unique localStorage key for this page and institution
  getFilterStorageKey() {
    return `rombel_filter_tambah_${this.state.institusi_id_select}`;
  }

  // Load filter from localStorage
  loadSavedFilter() {
    try {
      const savedFilter = localStorage.getItem(this.getFilterStorageKey());
      if (savedFilter) {
        const filter = JSON.parse(savedFilter);
        this.setState(
          {
            tahun_ajaran_search: filter.tahun_ajaran || "",
            kelas_search: filter.kelas || "",
            filterKurikulumSearch: filter.kurikulum || "k13",
            bidang_search: filter.bidang_id || "",
            bidang_search_label: filter.bidang_label || "",
            program_search: filter.program_id || "",
            program_search_label: filter.program_label || "",
            kompetensi_search: filter.kompetensi_id || "",
            kompetensi_search_label: filter.kompetensi_label || "",
            peminatan_search: filter.peminatan_id || "",
            peminatan_search_label: filter.peminatan_label || "",
            rombel_search: filter.rombel_id || "",
            rombel_search_label: filter.rombel_label || "",
            loadingFilter: false,
          },
          () => {
            if (this.state.filterKurikulumSearch) {
              this.getPeminatanSMA();
              this.getBidang();
            }
          },
        );
      } else {
        this.setState({ loadingFilter: false });
      }
    } catch (e) {
      console.warn("Failed to load saved filter:", e);
      this.setState({ loadingFilter: false });
    }
  }

  // Save filter to localStorage
  saveFilterToStorage() {
    const filter = {
      tahun_ajaran: this.state.tahun_ajaran_search,
      kelas: this.state.kelas_search,
      kurikulum: this.state.filterKurikulumSearch,
      bidang_id: this.state.bidang_search,
      bidang_label: this.state.bidang_search_label,
      program_id: this.state.program_search,
      program_label: this.state.program_search_label,
      kompetensi_id: this.state.kompetensi_search,
      kompetensi_label: this.state.kompetensi_search_label,
      peminatan_id: this.state.peminatan_search,
      peminatan_label: this.state.peminatan_search_label,
      rombel_id: this.state.rombel_search,
      rombel_label: this.state.rombel_search_label,
      savedAt: new Date().toISOString(),
    };
    try {
      localStorage.setItem(this.getFilterStorageKey(), JSON.stringify(filter));
    } catch (e) {
      console.warn("Failed to save filter:", e);
    }
  }

  // Clear saved filter from localStorage
  clearSavedFilter() {
    try {
      localStorage.removeItem(this.getFilterStorageKey());
    } catch (e) {
      console.warn("Failed to clear filter:", e);
    }
  }

  // ============ FILTER DATA GETTERS ============

  getTahunAjaranNow() {
    const ta = [];
    const tahunSekarang = this.state.tahunSekarang + 1;
    for (let i = tahunSekarang; i >= 2005; i--) {
      ta.push({ value: `${i - 1} / ${i}`, label: `${i - 1} / ${i}` });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  getKelas() {
    let kelas = [];
    // Convert to string to handle both number and string jenjang_id
    const jenjang = String(this.state.jenjang_id_select);

    if (jenjang === "1") {
      kelas = [
        { value: "TPA", label: "TPA (Taman Penitipan Anak)" },
        { value: "SPS", label: "SPS (Satuan PAUD Sejenis)" },
        { value: "KB", label: "KB (Kelompok Bermain)" },
        { value: "TK A", label: "TK A" },
        { value: "TK B", label: "TK B" },
      ];
    } else if (jenjang === "2") {
      kelas = [
        { value: "I", label: "I" },
        { value: "II", label: "II" },
        { value: "III", label: "III" },
        { value: "IV", label: "IV" },
        { value: "V", label: "V" },
        { value: "VI", label: "VI" },
      ];
    } else if (jenjang === "3") {
      kelas = [
        { value: "VII", label: "VII" },
        { value: "VIII", label: "VIII" },
        { value: "IX", label: "IX" },
      ];
    } else if (jenjang === "4" || jenjang === "5") {
      kelas = [
        { value: "X", label: "X" },
        { value: "XI", label: "XI" },
        { value: "XII", label: "XII" },
      ];
      if (jenjang === "5") {
        kelas.push({ value: "XIII", label: "XIII" });
      }
    }
    this.setState({ data_kelas: kelas });
  }

  getPeminatanSMA() {
    if (String(this.state.jenjang_id_select) === "4") {
      this.setState({ loading_peminatan: true });
      const kurikulum = this.state.filterKurikulumSearch || "k13";
      axios
        .get(
          `${this.state.url_get_spektrum}?jenjang=${this.state.jenjang_id_select}&kurikulum=${kurikulum}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({
            data_peminatan: res.data.status ? res.data.data : [],
            loading_peminatan: false,
          });
        })
        .catch(() => {
          this.setState({ loading_peminatan: false });
        });
    }
  }

  getBidang() {
    if (String(this.state.jenjang_id_select) === "5") {
      this.setState({ loading_bidang: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=0&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({ data_bidang: res.data, loading_bidang: false });
        })
        .catch(() => {
          this.setState({ loading_bidang: false });
        });
    }
  }

  getProgram() {
    if (
      String(this.state.jenjang_id_select) === "5" &&
      this.state.bidang_search
    ) {
      this.setState({ loading_program: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.bidang_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({ data_program: res.data, loading_program: false });
        })
        .catch(() => {
          this.setState({ loading_program: false });
        });
    }
  }

  getKompetensi() {
    if (
      String(this.state.jenjang_id_select) === "5" &&
      this.state.program_search &&
      this.state.filterKurikulumSearch === "k13"
    ) {
      this.setState({ loading_kompetensi: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.program_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({
            data_kompetensi: res.data,
            loading_kompetensi: false,
          });
        })
        .catch(() => {
          this.setState({ loading_kompetensi: false });
        });
    }
  }

  getRombel() {
    const peminatan =
      String(this.state.jenjang_id_select) === "5"
        ? this.state.kompetensi_search
        : this.state.peminatan_search;
    const kurikulum = this.state.filterKurikulumSearch || "k13";

    this.setState({ loading_rombel: true });
    axios
      .get(
        `${this.state.url_get_rombel}?tahun_ajaran=${this.state.tahun_ajaran_search}&kelas=${this.state.kelas_search}&peminatan=${peminatan}&user_institusi_id=${this.state.institusi_id_select}&kurikulum=${kurikulum}&program_id=${this.state.program_search}&bidang_id=${this.state.bidang_search}`,
        { headers: { Authorization: tokenApi } },
      )
      .then((res) => {
        this.setState({ data_rombel: res.data, loading_rombel: false });
      })
      .catch(() => {
        this.setState({ loading_rombel: false });
      });
  }

  // ============ FILTER HANDLERS ============

  filterTahunAjaran(e) {
    if (e) {
      this.setState({ tahun_ajaran_search: e.value }, () => {
        if (this.state.kelas_search) {
          this.getRombel();
        }
      });
    }
  }

  filterKurikulum(e) {
    if (e) {
      this.setState(
        {
          filterKurikulumSearch: e.value,
          peminatan_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
          rombel_search: "",
          data_peminatan: [],
          data_bidang: [],
          data_program: [],
          data_kompetensi: [],
          data_rombel: [],
        },
        () => {
          this.getPeminatanSMA();
          this.getBidang();
        },
      );
    }
  }

  filterKelas(e) {
    if (e) {
      this.setState(
        {
          kelas_search: e.value,
          peminatan_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
          rombel_search: "",
          rombel_search_label: "",
          data_rombel: [],
        },
        () => {
          this.getRombel();
        },
      );
    } else {
      this.setState({
        kelas_search: "",
        peminatan_search: "",
        bidang_search: "",
        program_search: "",
        kompetensi_search: "",
        rombel_search: "",
        rombel_search_label: "",
        data_rombel: [],
      });
    }
  }

  // Reset all filters
  resetFilters() {
    this.clearSavedFilter();
    this.setState({
      tahun_ajaran_search: "",
      filterKurikulumSearch: "",
      kelas_search: "",
      peminatan_search: "",
      peminatan_search_label: "",
      bidang_search: "",
      program_search: "",
      kompetensi_search: "",
      rombel_search: "",
      rombel_search_label: "",
      searchText: "",
      // data_kelas: [], // Preserve data_kelas as it depends only on jenjang
      data_peminatan: [],
      data_bidang: [],
      data_program: [],
      data_kompetensi: [],
      data_rombel: [],
      showDataTable: false,
    });
  }

  filterPeminatan(e) {
    if (e) {
      this.setState(
        {
          peminatan_search: e.value,
          peminatan_search_label: e.label,
          rombel_search: "",
        },
        () => {
          this.getRombel();
        },
      );
    } else {
      this.setState({
        peminatan_search: "",
        peminatan_search_label: "",
        rombel_search: "",
      });
    }
  }

  filterBidang(e) {
    if (e) {
      this.setState(
        {
          bidang_search: e.value,
          bidang_search_label: e.label,
          program_search: "",
          program_search_label: "",
          kompetensi_search: "",
          kompetensi_search_label: "",
          data_program: [],
          data_kompetensi: [],
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getProgram();
        },
      );
    } else {
      this.setState({
        bidang_search: "",
        bidang_search_label: "",
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        data_program: [],
        data_kompetensi: [],
      });
    }
  }

  filterProgram(e) {
    if (e) {
      this.setState(
        {
          program_search: e.value,
          program_search_label: e.label,
          kompetensi_search: "",
          kompetensi_search_label: "",
          data_kompetensi: [],
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          if (this.state.filterKurikulumSearch === "k13") {
            this.getKompetensi();
          } else {
            this.getRombel();
          }
        },
      );
    } else {
      this.setState({
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        data_kompetensi: [],
      });
    }
  }

  filterKompetensi(e) {
    if (e) {
      this.setState(
        {
          kompetensi_search: e.value,
          kompetensi_search_label: e.label,
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getRombel();
        },
      );
    } else {
      this.setState({
        kompetensi_search: "",
        kompetensi_search_label: "",
      });
    }
  }

  filterRombel(e) {
    if (e) {
      this.setState({
        rombel_search: e.value,
        rombel_search_label: e.label,
      });
    } else {
      this.setState({
        rombel_search: "",
        rombel_search_label: "",
      });
    }
  }

  // ============ ACTIONS ============

  // resetSelection: true untuk perubahan filter dropdown (tahun ajaran, kelas, dll),
  // false untuk pencarian teks biasa supaya checklist yang sudah dipilih tidak hilang.
  setFilter(resetSelection = true) {
    if (!this.state.rombel_search) {
      this.setState({
        show_alert: true,
        title_alert: "Peringatan",
        icon_alert: "warning",
        message_alert: "Pilih rombel tujuan terlebih dahulu",
      });
      return;
    }

    this.saveFilterToStorage();

    const peminatan =
      String(this.state.jenjang_id_select) === "5"
        ? this.state.kompetensi_search
        : this.state.peminatan_search;

    const query = `&tahun_ajaran=${this.state.tahun_ajaran_search}&kelas=${this.state.kelas_search}&m_spektrum_id=${peminatan}&user_institusi_id=${this.state.institusi_id_select}&kurikulum=${this.state.filterKurikulumSearch}&query=${this.state.searchText}&paginate=${this.state.mode_show}`;

    this.setState(
      {
        query,
        showDataTable: true,
        ...(resetSelection
          ? { selectedStudents: new Map() } // Reset hanya saat filter dropdown berubah
          : {}),
      },
      () => {
        if (this.dt) {
          this.dt.loading();
          this.dt.resetPage(query);
        }
      },
    );
  }

  handleSearch(e) {
    const searchText = e.target.value;
    this.setState({ searchText }, () => {
      // Debounce search
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.state.showDataTable) {
          // Jangan reset checklist saat sedang mencari nama
          this.setFilter(false);
        }
      }, 300);
    });
  }

  // FIXED: Persistent selection across pagination
  toggleStudentSelection(student) {
    this.setState((prevState) => {
      const newMap = new Map(prevState.selectedStudents);
      if (newMap.has(student.id)) {
        newMap.delete(student.id);
      } else {
        newMap.set(student.id, student);
      }
      return { selectedStudents: newMap };
    });
  }

  selectAllOnPage() {
    // Get all visible checkbox rows and click them to select
    const checkboxes = document.querySelectorAll("input.select-checkbox");
    checkboxes.forEach((cb) => {
      if (!cb.checked) {
        // Trigger the React onChange by simulating click
        const event = new MouseEvent("click", { bubbles: true });
        cb.dispatchEvent(event);
      }
    });
  }

  clearAllSelections() {
    this.setState({ selectedStudents: new Map() });
  }

  removeFromSelection(studentId) {
    this.setState((prevState) => {
      const newMap = new Map(prevState.selectedStudents);
      newMap.delete(studentId);
      return { selectedStudents: newMap };
    });
  }

  handleSubmit() {
    if (this.state.selectedStudents.size === 0) {
      this.setState({
        show_alert: true,
        title_alert: "Peringatan",
        icon_alert: "warning",
        message_alert: "Pilih minimal satu siswa terlebih dahulu",
      });
      return;
    }
    this.setState({ showConfirmModal: true });
  }

  confirmSubmit() {
    this.setState({ loading_submit: true, showConfirmModal: false });

    const studentIds = Array.from(this.state.selectedStudents.keys());

    axios
      .post(
        this.state.url_naik_kelas,
        {
          siswa_id: studentIds,
          tahun_ajaran: this.state.tahun_ajaran_search,
          rombel_id: this.state.rombel_search,
          created_by: this.state.institusi_id_select,
        },
        { headers: { Authorization: tokenApi } },
      )
      .then((res) => {
        this.setState(
          {
            loading_submit: false,
            showResultModal: true,
            resultData: {
              success: res.data.status,
              messages: res.data.messages,
              total: studentIds.length,
            },
            selectedStudents: new Map(),
          },
          () => {
            if (this.dt) {
              this.dt.fetchEntities(this.state.query);
            }
          },
        );
      })
      .catch((err) => {
        const errorMessage =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : "Terjadi kesalahan";
        this.setState({
          loading_submit: false,
          show_alert: true,
          title_alert: "Gagal",
          icon_alert: "error",
          message_alert: errorMessage,
        });
      });
  }

  // ============ RENDER METHODS ============

  renderFilterPanel() {
    return (
      <div className="glass-card p-6 mb-6">
        <div className="flex items-center mb-6">
          <div className="w-10 h-10 rounded-xl icon-gradient-indigo-violet flex items-center justify-center mr-3">
            <i className="bx bx-filter-alt text-white text-xl"></i>
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-800">
              Pilih Rombel Tujuan
            </h2>
            <p className="text-sm text-gray-500">
              Tentukan rombel untuk memasukkan siswa
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Tahun Ajaran */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                1
              </span>
              Tahun Ajaran
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_tahun_ajaran}
              value={
                this.state.tahun_ajaran_search
                  ? {
                      value: this.state.tahun_ajaran_search,
                      label: this.state.tahun_ajaran_search,
                    }
                  : null
              }
              onChange={this.filterTahunAjaran}
              placeholder="Pilih Tahun Ajaran"
              isLoading={this.state.loadingFilter}
            />
          </div>

          {/* Kurikulum - Disabled until Tahun Ajaran selected */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.tahun_ajaran_search ? "bg-indigo-100 text-indigo-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
              >
                2
              </span>
              Jenis Kurikulum
            </label>
            <Select
              styles={selectStyles}
              options={dataKurikulum}
              value={
                this.state.filterKurikulumSearch
                  ? {
                      value: this.state.filterKurikulumSearch,
                      label: this.state.filterKurikulumSearch.toUpperCase(),
                    }
                  : null
              }
              onChange={this.filterKurikulum}
              placeholder={
                this.state.tahun_ajaran_search
                  ? "Pilih Kurikulum"
                  : "Pilih Tahun Ajaran dulu"
              }
              isDisabled={!this.state.tahun_ajaran_search}
            />
          </div>

          {/* Kelas - Disabled until Kurikulum selected */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.filterKurikulumSearch ? "bg-indigo-100 text-indigo-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
              >
                3
              </span>
              Kelas
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_kelas}
              value={
                this.state.kelas_search
                  ? {
                      value: this.state.kelas_search,
                      label: this.state.kelas_search,
                    }
                  : null
              }
              onChange={this.filterKelas}
              placeholder={
                this.state.filterKurikulumSearch
                  ? "Pilih Kelas"
                  : "Pilih Kurikulum dulu"
              }
              isDisabled={!this.state.filterKurikulumSearch}
            />
          </div>

          {/* Peminatan/Jurusan - SMA - Disabled until Kelas selected */}
          {String(this.state.jenjang_id_select) === "4" && (
            <div className="filter-group">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span
                  className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kelas_search ? "bg-indigo-100 text-indigo-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
                >
                  4
                </span>
                Peminatan
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_peminatan}
                value={
                  this.state.peminatan_search
                    ? {
                        value: this.state.peminatan_search,
                        label:
                          this.state.peminatan_search_label ||
                          this.state.peminatan_search,
                      }
                    : null
                }
                onChange={this.filterPeminatan}
                placeholder={
                  this.state.kelas_search
                    ? "Pilih Peminatan"
                    : "Pilih Kelas dulu"
                }
                isLoading={this.state.loading_peminatan}
                isDisabled={!this.state.kelas_search}
              />
            </div>
          )}

          {/* SMK - Bidang, Program, Kompetensi */}
          {String(this.state.jenjang_id_select) === "5" &&
            this.renderSMKFilters()}

          {/* Rombel - Disabled until Kelas selected */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kelas_search ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
              >
                5
              </span>
              Rombel Tujuan
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_rombel}
              value={
                this.state.rombel_search
                  ? {
                      value: this.state.rombel_search,
                      label: this.state.rombel_search_label,
                    }
                  : null
              }
              onChange={this.filterRombel}
              placeholder={
                this.state.kelas_search ? "Pilih Rombel" : "Pilih Kelas dulu"
              }
              isLoading={this.state.loading_rombel}
              isDisabled={!this.state.kelas_search}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 flex justify-center gap-3">
          <button
            className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center"
            onClick={this.resetFilters}
          >
            <i className="bx bx-reset text-xl mr-2"></i>
            Reset Filter
          </button>
          <button
            className={`px-8 py-3 ${this.state.rombel_search ? "btn-gradient-indigo hover:shadow-xl transform hover:-translate-y-0.5" : "bg-gray-300 cursor-not-allowed"} text-white font-semibold rounded-xl shadow-lg transition-all duration-200 flex items-center`}
            onClick={this.setFilter}
            disabled={!this.state.rombel_search}
          >
            <i className="bx bx-search-alt-2 text-xl mr-2"></i>
            Tampilkan Daftar Siswa
          </button>
        </div>
      </div>
    );
  }

  renderSMKFilters() {
    return (
      <>
        {/* Bidang */}
        <div className="filter-group">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
              4a
            </span>
            Bidang Keahlian
          </label>
          <Select
            styles={selectStyles}
            options={this.state.data_bidang}
            value={
              this.state.bidang_search
                ? {
                    value: this.state.bidang_search,
                    label:
                      this.state.bidang_search_label ||
                      this.state.bidang_search,
                  }
                : null
            }
            onChange={this.filterBidang}
            placeholder="Pilih Bidang"
            isLoading={this.state.loading_bidang}
            isClearable
          />
        </div>

        {/* Program */}
        {this.state.bidang_search && (
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                4b
              </span>
              Program Keahlian
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_program}
              value={
                this.state.program_search
                  ? {
                      value: this.state.program_search,
                      label:
                        this.state.program_search_label ||
                        this.state.program_search,
                    }
                  : null
              }
              onChange={this.filterProgram}
              placeholder="Pilih Program"
              isLoading={this.state.loading_program}
              isClearable
            />
          </div>
        )}

        {/* Kompetensi - only for K13 */}
        {this.state.program_search &&
          this.state.filterKurikulumSearch === "k13" && (
            <div className="filter-group">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                  4c
                </span>
                Kompetensi Keahlian
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_kompetensi}
                value={
                  this.state.kompetensi_search
                    ? {
                        value: this.state.kompetensi_search,
                        label:
                          this.state.kompetensi_search_label ||
                          this.state.kompetensi_search,
                      }
                    : null
                }
                onChange={this.filterKompetensi}
                placeholder="Pilih Kompetensi"
                isLoading={this.state.loading_kompetensi}
                isClearable
              />
            </div>
          )}
      </>
    );
  }

  renderDataTable() {
    if (!this.state.showDataTable) return null;

    return (
      <div className="glass-card p-6 mb-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl icon-gradient-blue-cyan flex items-center justify-center mr-3">
              <i className="bx bx-user-plus text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">Daftar Siswa</h2>
              <p className="text-sm text-gray-500">
                Pilih daftar siswa ke rombel
              </p>
            </div>
          </div>

          {/* Search and Pagination Controls */}
          <div className="flex items-center gap-4">
            <div className="relative">
              <input
                type="search"
                className="pl-10 pr-4 py-2 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 outline-none transition-all w-64"
                placeholder="Cari nama atau kode..."
                onChange={this.handleSearch}
              />
              <i className="bx bx-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
            </div>

            <div className="flex items-center gap-2">
              {[10, 50, 100].map((num) => (
                <button
                  key={num}
                  className={`px-3 py-1 rounded-lg text-sm font-medium transition-all ${
                    this.state.mode_show === num
                      ? "bg-indigo-500 text-white"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                  onClick={() =>
                    this.setState({ mode_show: num }, this.setFilter)
                  }
                >
                  {num}
                </button>
              ))}
            </div>

            {/* Select All Button */}
            <button
              className="px-4 py-2 bg-indigo-100 text-indigo-700 font-medium rounded-lg hover:bg-indigo-200 transition-all flex items-center text-sm"
              onClick={this.selectAllOnPage}
            >
              <i className="bx bx-check-double text-lg mr-1"></i>
              Pilih Semua
            </button>
          </div>
        </div>

        {/* DataTable */}
        <DataTable
          ref={(dt) => {
            this.dt = dt;
          }}
          action={{
            no: (col, data, index) => {
              const page =
                this.dt?.state?.entities?.current_page ||
                this.dt?.state?.current_page ||
                1;
              const perPage =
                this.dt?.state?.entities?.per_page ||
                this.state.mode_show ||
                10;
              return (page - 1) * perPage + index + 1;
            },
            pilih: (col, data) => (
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="select-checkbox sr-only peer"
                  checked={this.state.selectedStudents.has(data.id)}
                  onChange={() => this.toggleStudentSelection(data)}
                />
                <div className="w-6 h-6 rounded-lg border-2 border-gray-300 peer-checked:border-indigo-500 peer-checked:bg-indigo-500 flex items-center justify-center transition-all">
                  <i
                    className={`bx bx-check text-white ${this.state.selectedStudents.has(data.id) ? "opacity-100" : "opacity-0"} transition-opacity`}
                  ></i>
                </div>
              </label>
            ),
            jenis_kelamin: (col, data) => {
              // Handle 0 (Female) correctly by not using || operator which treats 0 as falsy
              const rawVal = data.jenis_kelamin;
              const val = (
                rawVal !== null && rawVal !== undefined ? String(rawVal) : ""
              )
                .toUpperCase()
                .trim();

              const isMale =
                val === "1" ||
                val === "L" ||
                val === "M" ||
                val === "LAKI-LAKI" ||
                val === "LAKI - LAKI" ||
                val === "MALE";
              const isFemale =
                val === "0" ||
                val === "P" ||
                val === "F" ||
                val === "PEREMPUAN" ||
                val === "FEMALE";

              let label = isMale ? "L" : isFemale ? "P" : "-";
              let color = isMale
                ? "bg-blue-100 text-blue-700"
                : isFemale
                  ? "bg-pink-100 text-pink-700"
                  : "bg-gray-100 text-gray-700";

              return (
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}
                >
                  {label}
                </span>
              );
            },
            tanggal_lahir: (col, data) => {
              if (!data.tanggal_lahir) return "-";
              const date = new Date(data.tanggal_lahir);
              return date.toLocaleDateString("id-ID", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              });
            },
            status: (col, data) => {
              const val = String(data.status || "")
                .toLowerCase()
                .trim();
              const isActive =
                val === "aktif" ||
                val === "active" ||
                val === "1" ||
                val === "true";
              const isNonActive =
                val === "non-aktif" ||
                val === "non-active" ||
                val === "inactive" ||
                val === "0" ||
                val === "false";

              let label = isActive
                ? "Aktif"
                : isNonActive
                  ? "Non-Aktif"
                  : data.status || "Pending";
              let color = isActive
                ? "bg-green-100 text-green-700"
                : isNonActive
                  ? "bg-red-100 text-red-700"
                  : "bg-yellow-100 text-yellow-700";

              return (
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}
                >
                  {label}
                </span>
              );
            },
          }}
          url={this.state.url}
          columns={[
            { index: "no", label: "No" },
            { index: "kode_pendaftaran", label: "Kode Pendaftaran" },
            { index: "nama", label: "Nama Lengkap" },
            { index: "email", label: "Email" },
            { index: "jenis_kelamin", label: "JK" },
            { index: "tanggal_lahir", label: "Tanggal Lahir" },
            { index: "status", label: "Status" },
            { index: "pilih", label: "Pilih" },
          ]}
        />
      </div>
    );
  }

  renderSelectionPanel() {
    const selectedCount = this.state.selectedStudents.size;
    const selectedStudents = Array.from(this.state.selectedStudents.values());

    return (
      <div className="glass-card p-6 sticky top-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl icon-gradient-emerald-teal flex items-center justify-center mr-3">
              <i className="bx bx-list-check text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">
                Daftar Siswa Terpilih
              </h2>
              <p className="text-sm text-gray-500">
                {selectedCount} siswa dipilih
              </p>
            </div>
          </div>
          {selectedCount > 0 && (
            <button
              className="text-red-500 hover:text-red-700 text-sm font-medium"
              onClick={this.clearAllSelections}
            >
              Hapus Semua
            </button>
          )}
        </div>

        {/* Selected Students List */}
        <div className="max-h-96 overflow-y-auto space-y-2 mb-4">
          {selectedCount === 0 ? (
            <div className="text-center py-8 text-gray-400">
              <i className="bx bx-user-plus text-4xl mb-2"></i>
              <p className="text-sm">Belum ada siswa dipilih</p>
              <p className="text-xs">Centang siswa dari daftar di samping</p>
            </div>
          ) : (
            selectedStudents.map((student) => (
              <div
                key={student.id}
                className="flex items-center justify-between p-3 bg-gradient-to-r from-gray-50 to-white rounded-xl border border-gray-100 hover:shadow-md transition-all group"
              >
                <div className="flex items-center">
                  <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center mr-3">
                    <i className="bx bx-user text-indigo-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800 text-sm">
                      {student.nama}
                    </p>
                    <p className="text-xs text-gray-500">
                      {student.kode_pendaftaran}
                    </p>
                  </div>
                </div>
                <button
                  className="opacity-0 group-hover:opacity-100 w-6 h-6 rounded-full bg-red-100 text-red-500 hover:bg-red-500 hover:text-white flex items-center justify-center transition-all"
                  onClick={() => this.removeFromSelection(student.id)}
                >
                  <i className="bx bx-x"></i>
                </button>
              </div>
            ))
          )}
        </div>

        {/* Submit Button */}
        {selectedCount > 0 && (
          <button
            className="w-full py-3 btn-gradient-emerald font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center text-white"
            onClick={this.handleSubmit}
            disabled={this.state.loading_submit}
          >
            {this.state.loading_submit ? (
              <UserButtonLoading />
            ) : (
              <>
                <i className="bx bx-check-circle text-xl mr-2"></i>
                Masukkan ke Rombel
              </>
            )}
          </button>
        )}

        {/* Rombel Info */}
        {this.state.rombel_search_label && (
          <div className="mt-4 p-3 bg-indigo-50 rounded-xl border border-indigo-100">
            <p className="text-xs text-indigo-600 font-medium mb-1">
              Rombel Tujuan:
            </p>
            <p className="text-sm font-bold text-indigo-800">
              {this.state.rombel_search_label}
            </p>
          </div>
        )}
      </div>
    );
  }

  renderConfirmModal() {
    const selectedStudents = Array.from(this.state.selectedStudents.values());

    return (
      <Modal
        show={this.state.showConfirmModal}
        onHide={() => this.setState({ showConfirmModal: false })}
        size="lg"
        centered
      >
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center mb-4">
              <i className="bx bx-help-circle text-amber-500 text-4xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800">
              Konfirmasi Masuk Rombel
            </h3>
            <p className="text-gray-500 mt-2">
              Anda akan memasukkan{" "}
              <strong>{selectedStudents.length} siswa</strong> ke rombel
              <strong className="text-indigo-600">
                {" "}
                {this.state.rombel_search_label}
              </strong>
            </p>
          </div>

          {/* Student List */}
          <div className="max-h-64 overflow-y-auto mb-6 border rounded-xl">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">
                    No
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">
                    Nama Siswa
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-600">
                    Kode Pendaftaran
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {selectedStudents.map((student, idx) => (
                  <tr key={student.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-gray-500">{idx + 1}</td>
                    <td className="px-4 py-3 font-medium text-gray-800">
                      {student.nama}
                    </td>
                    <td className="px-4 py-3 text-gray-600">
                      {student.kode_pendaftaran}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Actions */}
          <div className="flex gap-3 justify-end">
            <button
              className="px-6 py-2 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-all"
              onClick={() => this.setState({ showConfirmModal: false })}
            >
              Batal
            </button>
            <button
              className="px-6 py-2 rounded-xl btn-gradient-emerald font-medium hover:shadow-lg transition-all flex items-center"
              onClick={this.confirmSubmit}
              disabled={this.state.loading_submit}
            >
              {this.state.loading_submit ? (
                <UserButtonLoading />
              ) : (
                <>
                  <i className="bx bx-check mr-2"></i>
                  Ya, Masukkan Semua
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  renderResultModal() {
    const { resultData } = this.state;
    if (!resultData) return null;

    return (
      <Modal
        show={this.state.showResultModal}
        onHide={() =>
          this.setState({ showResultModal: false, resultData: null })
        }
        centered
      >
        <div className="p-6 text-center">
          <div
            className={`w-20 h-20 mx-auto rounded-full ${resultData.success ? "bg-green-100" : "bg-red-100"} flex items-center justify-center mb-4`}
          >
            <i
              className={`bx ${resultData.success ? "bx-check-circle text-green-500" : "bx-x-circle text-red-500"} text-5xl`}
            ></i>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-2">
            {resultData.success ? "Berhasil!" : "Terjadi Kesalahan"}
          </h3>

          <div className="mb-6">
            {Array.isArray(resultData.messages) ? (
              resultData.messages.map((msg, idx) => (
                <p key={idx} className="text-gray-600">
                  {msg}
                </p>
              ))
            ) : (
              <p className="text-gray-600">{resultData.messages}</p>
            )}
          </div>

          <div className="flex justify-center gap-4 mb-6">
            <div className="px-6 py-4 bg-green-50 rounded-xl text-center">
              <p className="text-2xl font-bold text-green-600">
                {resultData.total}
              </p>
              <p className="text-sm text-green-700">Total Diproses</p>
            </div>
          </div>

          <button
            className="px-8 py-2 btn-gradient-indigo rounded-xl font-medium hover:shadow-lg transition-all text-white"
            onClick={() =>
              this.setState({ showResultModal: false, resultData: null })
            }
          >
            Tutup
          </button>
        </div>
      </Modal>
    );
  }

  renderTabNavigation() {
    return (
      <div className="flex justify-center mb-8">
        <div className="bg-white p-1.5 rounded-2xl shadow-sm border border-gray-200 inline-flex relative">
          {/* Sliding Background */}
          <div
            className={`absolute top-1.5 bottom-1.5 rounded-xl tab-slider-gradient shadow-md transition-all duration-300 ease-out`}
            style={{
              left: this.state.activeTab === "tambah" ? "0.375rem" : "50%",
              width: "calc(50% - 0.375rem)",
              transform:
                this.state.activeTab === "naik_kelas"
                  ? "translateX(0%)"
                  : "none",
            }}
          ></div>

          {/* Tab 1: Tambah Siswa */}
          <button
            onClick={() => this.setState({ activeTab: "tambah" })}
            className={`relative z-10 px-8 py-2.5 rounded-xl text-sm font-semibold transition-colors duration-200 flex items-center gap-2 ${
              this.state.activeTab === "tambah"
                ? "text-white"
                : "text-gray-600 hover:text-gray-800"
            }`}
            style={{ minWidth: "180px", justifyContent: "center" }}
          >
            <i
              className={`bx ${this.state.activeTab === "tambah" ? "bxs-user-plus" : "bx-user-plus"} text-lg`}
            ></i>
            Siswa Baru / Pindahan
          </button>

          {/* Tab 2: Kenaikan Kelas */}
          <button
            onClick={() => this.setState({ activeTab: "naik_kelas" })}
            className={`relative z-10 px-8 py-2.5 rounded-xl text-sm font-semibold transition-colors duration-200 flex items-center gap-2 ${
              this.state.activeTab === "naik_kelas"
                ? "text-white"
                : "text-gray-600 hover:text-gray-800"
            }`}
            style={{ minWidth: "180px", justifyContent: "center" }}
          >
            <i
              className={`bx ${this.state.activeTab === "naik_kelas" ? "bxs-up-arrow-circle" : "bx-up-arrow-circle"} text-lg`}
            ></i>
            Proses Kenaikan Kelas
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-6">
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
        />

        <div className="sm-container mx-auto px-4">
          {/* Tab Navigation */}
          {this.renderTabNavigation()}

          {this.state.activeTab === "tambah" ? (
            <>
              {/* Header */}
              <div className="mb-6 animateFadeInUp">
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-2xl icon-gradient-indigo-violet flex items-center justify-center mr-4 shadow-lg">
                    <i className="bx bx-user-plus text-white text-2xl"></i>
                  </div>
                  <div>
                    <h1 className="text-2xl font-bold text-gray-800">
                      Tambah Siswa ke Rombel
                    </h1>
                    <p className="text-gray-500">
                      Kelola penempatan siswa ke dalam rombongan belajar
                    </p>
                  </div>
                </div>
              </div>

              {/* Loading State */}
              {this.state.loadingFilter ? (
                <div className="glass-card p-8">
                  <div className="flex flex-col items-center justify-center">
                    <Skeleton width={200} height={20} className="mb-4" />
                    <Skeleton width={300} height={40} className="mb-2" />
                    <Skeleton width={300} height={40} className="mb-2" />
                    <Skeleton width={300} height={40} />
                  </div>
                </div>
              ) : (
                <>
                  {/* Filter Panel */}
                  {this.renderFilterPanel()}

                  {/* Main Content - Two Column Layout */}
                  {this.state.showDataTable && (
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                      {/* DataTable - 2/3 width */}
                      <div className="lg:col-span-2">
                        {this.renderDataTable()}
                      </div>

                      {/* Selection Panel - 1/3 width */}
                      <div className="lg:col-span-1">
                        {this.renderSelectionPanel()}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <div className="animateFadeInUp">
              <KenaikanSiswa />
            </div>
          )}
        </div>

        {/* Modals */}
        {this.renderConfirmModal()}
        {this.renderResultModal()}
      </div>
    );
  }
}